"use client";

import { FlexColumn, FlexRowAlignCenter } from "@/components/Flex";
import UserAvatar from "@/components/userCardComponents/UserAvatar";
import { User } from "@knowt/syncing/graphql/schema";
import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import LevelsIcon from "@/components/icons/LevelsIcon";
import { ConditionalLink } from "../ConditionalLink";

export const UserProfileCard = ({
    name,
    email,
    img,
    style,
}: {
    name: string;
    email: string;
    img: string;
    style?: React.CSSProperties;
}) => {
    return (
        <FlexRowAlignCenter style={{ gap: "inherit", overflow: "hidden", fontSize: "1.5rem", flex: 1, ...style }}>
            <UserAvatar src={img} radius={"6rem"} alt={name[0]} />
            <FlexColumn style={{ gap: "0.5rem", fontWeight: "bold", textAlign: "left" }}>
                <span className="clampText" style={{ WebkitLineClamp: 1 }}>
                    {name}
                </span>
                <span className="clampText" style={{ fontSize: "0.9em", color: "darkgrey", WebkitLineClamp: 1 }}>
                    {email}
                </span>
            </FlexColumn>
        </FlexRowAlignCenter>
    );
};

type UserProfileCardWithFollowHandlerProps = {
    user: User;
};

export const UserProfileCardWithFollowHandler = ({ user }: UserProfileCardWithFollowHandlerProps) => {
    const isAnonymous = user.username === "redacted" && user.Name === "Anonymous User";

    return (
        <ConditionalLink condition={!isAnonymous} href={`/u/${user.username}`}>
            <FlexRowAlignCenter style={{ justifyContent: "space-between", gap: "1.3rem" }}>
                <UserProfileCard
                    name={user?.Name || ""}
                    username={user?.username || "unnamed"}
                    img={user.pictureUrl || ""}
                />
                <CircularRectTextButton
                    component="div"
                    sx={{
                        position: "relative",
                        width: "8rem",
                        height: "4.2rem",
                        gap: "8px",
                        backgroundColor: "#EBE2FF",
                        "&:hover": {},
                        "&:active": {},
                    }}>
                    <LevelsIcon level={"LV"} size={21} />
                    <div style={{ textAlign: "center", color: "#092522" }} className={"bodyBold2"}>
                        {user.level ?? "0"}
                    </div>
                </CircularRectTextButton>
            </FlexRowAlignCenter>
        </ConditionalLink>
    );
};
